"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
const React = require("react");
const react_native_1 = require("react-native");
const theme_1 = require("../modules/theme");
const test_1 = require("../modules/test");
class ErrorMessage extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                errorMessage: {
                    fontFamily: theme.fontFamily3,
                    color: theme.errorColor
                }
            });
            return styles;
        };
    }
    render() {
        const { message, style, nativeID } = this.props;
        const styles = this.getStyles();
        if (!message) {
            return null;
        }
        return (React.createElement(react_native_1.Text, { nativeID: nativeID, testID: (0, test_1.getTestID)(nativeID), style: [styles.errorMessage, style] }, message));
    }
}
exports.ErrorMessage = ErrorMessage;
